import React from 'react';
import { useTheme } from "@mui/styles";
import { useSelector } from 'react-redux';
import { selectRenegotiationsPieChartData } from '../../../../../slices/teamStatsSlice';
import AnalyticsPieCard from './AnalyticsPieCard';

const RenegotiationsPieChart = () => {
  const theme = useTheme();

  const pieChartData = useSelector(selectRenegotiationsPieChartData)
  
  const COLORS = [`${theme.tier.one.primary}`, `${theme.tier.two.primary}`, `${theme.closure.manual.primary}`];

  return (
    <AnalyticsPieCard
      title="Renegotiations"
      pieChartData={pieChartData}
      colors={COLORS}
      legendItems={[
        { label: "Tier 1", value: pieChartData !== undefined ? pieChartData[0].size : <></>, color: theme.tier.one.primary },
        { label: "Tier 2", value: pieChartData !== undefined ? pieChartData[1].size : <></>, color: theme.tier.two.primary },
        { label: "Manual", value: pieChartData !== undefined ? pieChartData[2].size : <></>, color: theme.closure.manual.primary },
      ]}
      emptyText="no closures"
    />
  )
}

export default RenegotiationsPieChart;
